import apiClient from './api';
import {
  BugReport,
  CreateBugReportRequest,
  UpdateBugReportRequest,
} from '../types';

export const bugReportService = {
  // 내 오류 신고 목록 조회
  async getMyBugReports(): Promise<BugReport[]> {
    const response = await apiClient.get<BugReport[]>('/bug-reports');
    return response.data;
  },

  // 특정 오류 신고 조회
  async getBugReport(reportId: string): Promise<BugReport> {
    const response = await apiClient.get<BugReport>(`/bug-reports/${reportId}`);
    return response.data;
  },

  // 오류 신고 작성
  async createBugReport(bugReportData: CreateBugReportRequest): Promise<BugReport> {
    const response = await apiClient.post<BugReport>('/bug-reports', bugReportData);
    return response.data;
  },

  // 오류 신고 처리 (ADMIN만)
  async updateBugReport(reportId: string, updateData: UpdateBugReportRequest): Promise<BugReport> {
    const response = await apiClient.patch<BugReport>(`/bug-reports/${reportId}`, updateData);
    return response.data;
  },

  // 오류 신고 삭제 (ADMIN만)
  async deleteBugReport(reportId: string): Promise<void> {
    await apiClient.delete(`/bug-reports/${reportId}`);
  },

  // 상태별 필터링
  filterByStatus(reports: BugReport[], status: string): BugReport[] {
    if (!status) return reports;
    return reports.filter(report => report.status === status);
  },

  // 상태 텍스트 변환
  getStatusText(status: string): string {
    switch (status) {
      case 'PENDING':
        return '대기 중';
      case 'RESOLVED':
        return '해결됨';
      default:
        return status;
    }
  },

  // 상태 색상 반환
  getStatusColor(status: string): string {
    switch (status) {
      case 'PENDING':
        return 'orange';
      case 'RESOLVED':
        return 'green';
      default:
        return 'default';
    }
  },
}; 